import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e60a8c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upgrade-modal-content" }
const _hoisted_2 = {
  key: 0,
  class: "message-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text-fill text-primary upgrade-icon" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "upgrade-title" }, "This is a legacy resume format", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upgrade-description" }, " Please click upgrade to automatically upgrade your existing resume to the new format, and ensure your resume works with our new features. ", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "message-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success upgrade-icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "upgrade-title" }, "Resume Upgraded Successfully", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upgrade-description" }, " Your resume has been upgraded to the new format. Would you like to view it now? ", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "loading-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loading-text mt-3" }, "Upgrading your resume... This may take up to 20 seconds.", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "button-container"
}
const _hoisted_17 = {
  key: 4,
  class: "button-container"
}

import { ref } from "vue";
import Modal from "./Modal.vue";
import { DocumentApiService } from "../services/DocumentApiService";
import { toast } from "vue3-toastify";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeResumeModal',
  props: {
    resumeId: {}
  },
  emits: ["upgrade-complete", "view-resume"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const modalRef = ref<InstanceType<typeof Modal> | null>(null);
const isLoading = ref(false);
const isComplete = ref(false);
const newResumeId = ref<string | null>(null);

const show = () => {
  modalRef.value?.show();
};

const closeModal = () => {
  if (isLoading.value) return; // Prevent closing while loading
  modalRef.value?.hide();
  
  // Reset state when closing
  if (isComplete.value) {
    setTimeout(() => {
      isComplete.value = false;
      newResumeId.value = null;
    }, 300);
  }
};

const viewNewResume = () => {
  if (newResumeId.value !== null && newResumeId.value !== undefined) {
    emit("view-resume", newResumeId.value);
    closeModal();
  }
};

const upgradeResume = async () => {
  try {
    isLoading.value = true;
    const response = await DocumentApiService.upgradeResume({resumeId: props.resumeId});
    
    // Store the new resume ID
    newResumeId.value = response.data.id || null;
    
    // Update state to show success view
    isComplete.value = true;
    
    // Emit the event with the upgraded resume
    emit("upgrade-complete", response.data);
    
    toast.success("Resume upgraded successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } catch (error) {
    console.error("Error upgrading resume:", error);
    toast.error("Failed to upgrade resume", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
  closeModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    hideFooter: true,
    "hide-close-button": "",
    "hide-header": ""
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!isLoading.value && !isComplete.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
          : _createCommentVNode("", true),
        (isComplete.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
          : _createCommentVNode("", true),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
          : (isComplete.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: closeModal
                }, "Close"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: viewNewResume
                }, "View Resume")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: closeModal
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: upgradeResume
                }, "Upgrade")
              ]))
      ])
    ]),
    _: 1
  }, 512))
}
}

})